import { AddCircle } from "@mui/icons-material";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { ConfigProvider, Space, Table, theme, Button as AntButton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { ConfigOperationsContext } from ".";
import { CarFilled, DeleteFilled, EditFilled } from "@ant-design/icons";
import Swal from "sweetalert2";
import { notiError, notiSuccess } from "../utils/notiUltils";
import VehicleAuthorization from "./VehicleAuthorization";
import { blue } from "@mui/material/colors";

function PointPreview() {
  const muiTheme = useTheme();
  const {
    setOperation,
    datagGoFences,
    setDataGeoFences,
    loading,
    onRow,
    onEdit,
    api,
  } = useContext(ConfigOperationsContext);
  //const [tableHeight, setTableHeight] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState("");

  const [open, setOpen] = useState(false);

  const rowClassName = (record) => {
    return record.key === selectedRow
      ? muiTheme.palette.mode === "dark"
        ? "highlighted-row-dark"
        : "highlighted-row"
      : "";
  };

  const onClickAdd = () => {
    setSelectedRow(null);
    onRow(null);
    setOperation(2);
  };

  let editable = false;
  let deleteable = false;
  let authorizationable = false;
  const onRowClick = (record) => {
    if (editable) {
      editable = false;
      return;
    }
    if (deleteable) {
      deleteable = false;
      return;
    }
    if (authorizationable) {
      authorizationable = false;
      return;
    }
    onRow(record);
    setSelectedRow(record.key);
  };
  const onEditClick = (record) => {
    editable = true;
    onEdit(record);
    setSelectedRow(record.key);
    setOperation(3);
  };
  const onDelete = async (record) => {
    deleteable = true;
    try {
      const resultDel = await Swal.fire({
        title: `ลบข้อมูล ${record.LocationName}`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#1976D2",
      });

      if (resultDel.isConfirmed) {
        const result = await api.delete(
          `/geoFences/${record.GeoFenceID}`,
          null,
          localStorage.getItem("token")
        );
        const index = datagGoFences.findIndex(
          (a) => a.GeoFenceID === record.GeoFenceID
        );
        datagGoFences[index]?.overlay?.setMap(null);
        onRow(null);
        datagGoFences.splice(index, 1);
        setDataGeoFences([...datagGoFences]);
        notiSuccess({ message: result.message, position: "center" });
      }
    } catch (error) {
      console.log(error);
      notiError({ message: error, position: "center" });
    }
  };
  const onAuthorization = (record) => {
    authorizationable = true;
    setSelectedPoint(record);
    setOpen(true);
  };

  /*useEffect(() => {
    const handleOnWindowResize = () => {
      const screenHeight = window.innerHeight;
      setTableHeight(screenHeight - 295);
    };
    window.addEventListener("resize", handleOnWindowResize);
    handleOnWindowResize();
    return () => {
      window.removeEventListener("resize", handleOnWindowResize);
    };
  }, []);*/

  useEffect(() => {
    const elements = document.getElementsByClassName("ant-table-body");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.overflow = "auto";
    }
  }, [datagGoFences]);

  return (
    <>
      {/* <img
        src={muiTheme.palette.mode === "dark" ? g3 : g31}
        height={100}
        width={"100%"}
        alt=""
      /> */}
      <CardHeader
        title="พื้นที่จุดเสี่ยงจุดอันตราย"
        titleTypographyProps={{ variant: "h5", fontWeight: 700 }}
        sx={{ bgcolor: blue[100] }}
      />
      <Divider />
      <CardContent className="animate__animated animate__flipInY">
        <Stack>
          {/* <Typography color="#223862" textAlign={"center"} variant="h6">
            พื้นที่จุดเสี่ยงจุดอันตราย
          </Typography> */}
          <Button
            onClick={onClickAdd}
            startIcon={<AddCircle />}
            variant="contained"
            size="large"
          >
            สร้างพื้นที่จุดเสี่ยงจุดอันตราย
          </Button>
        </Stack>
        <Card
          elevation={0}
          variant="outlined"
          sx={{ bgcolor: blue[100], mt: 1.5 }}
        >
          <CardContent>
            <Typography sx={{mb:1}} variant="subtitle2" fontWeight={700}>
              ตารางแสดงข้อมูล
            </Typography>
            <ConfigProvider
              theme={{
                token:
                  muiTheme.palette.mode === "dark"
                    ? {
                        fontFamily: "kanit",
                        //colorBgContainer: "transparent",
                        //colorBgBase: "#494d56",
                      }
                    : {
                        fontFamily: "kanit",
                        //colorBgContainer: "transparent",
                      },
                algorithm:
                  muiTheme.palette.mode === "dark"
                    ? theme.darkAlgorithm
                    : theme.defaultAlgorithm,
              }}
            >
              <Table
                columns={[
                  {
                    title: "Operate",
                    align: "center",
                    width: 120,
                    render: (record) => (
                      <Space>
                        <AntButton
                          size="small"
                          onClick={() => onEditClick(record)}
                          shape="circle"
                          icon={<EditFilled />}
                        />
                        <AntButton
                          size="small"
                          onClick={() => onDelete(record)}
                          shape="circle"
                          icon={<DeleteFilled />}
                        />
                        <AntButton
                          onClick={() => onAuthorization(record)}
                          size="small"
                          shape="circle"
                          icon={<CarFilled />}
                        />
                      </Space>
                    ),
                  },
                  { title: "Location", dataIndex: "LocationName" },
                  { title: "Category", dataIndex: "CategoryName" },
                ]}
                //pagination={false}
                loading={loading}
                dataSource={datagGoFences}
                scroll={{ y: "calc(100vh - 325px)" }}
                onRow={(record) => ({
                  onClick: () => {
                    onRowClick(record);
                  },
                })}
                rowClassName={rowClassName}
                pagination={false}
                //bordered
                //pagination={{ pageSize: 20 }}
              />
            </ConfigProvider>
          </CardContent>
        </Card>
      </CardContent>
      {/* <img
        src={muiTheme.palette.mode === "dark" ? g2 : g21}
        height={120}
        width={"100%"}
        alt=""
        style={{ position: "absolute", bottom: 0 }}
      /> */}
      {open && (
        <VehicleAuthorization
          open={open}
          setOpen={setOpen}
          selectedPoint={selectedPoint}
        />
      )}
    </>
  );
}

export default PointPreview;
